module.exports = __webpack_public_path__ + "img/icon_submenu2.5a2aa78a.svg";